// CLASSES
import AppConfig from "@classes/AppConfig";

export default function(props, state)
{
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true)
	{
		return true;
	}

	const {fields, validFields} = state;

	for (const name in validFields)
	{
		if (validFields[name] === false)
		{
			return false;
		}
	}

	if (fields.customer_occupation_last24m.length <= 0)
	{
		return false;
	}

	if (fields.customer_occupation.length <= 0)
	{
		return false;
	}

	/**
	 * Customer needs to be owner of funds, otherwise no account can be opened
	 */
	if (!fields.checkbox_aml_own_money.options[1].checked)
	{
		return false;
	}


	/**
	 * PEP persons 
	 */
	if (!fields.pep_fields_valid)
	{
		return false;
	}

	return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Fair/Kyc/Kyc.fulfillment.js